module.exports = __webpack_public_path__ + "img/indethuisstudio@small.a72863ee.png";